<template>
    <div>
      <div v-if="loading" class="C-PageLoading">
        <div class="Spinner spinner-grow text-primary"></div>
      </div>
      <el-card v-if="!loading" shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
        <el-button round size="small" @click = 'click_new_url'> 最新地址</el-button>
        <el-button round size="small" @click = 'click_identify'> 鉴别指南</el-button>
        <el-button round size="small" @click = 'click_rule' > 积分规则</el-button>
      </el-card>
      <el-card v-if="!loading" shadow="never" :body-style="{padding: '16px',textAlign: 'left'}" v-show="new_url">
          <div class="G-title">
            <span>最新地址</span>
          </div>
          <pre v-html="this.new">
          </pre>
        </el-card>
      <el-card v-if="!loading" shadow="never" :body-style="{padding: '16px',textAlign: 'left'}" v-show="identify">
        <div class="G-title">
          <span>鉴别指南</span>
        </div>
          <ol style="padding-inline-start: 15px;">
          <li><strong>怎么辨别和鉴定虚假联系方式？骗子有一些显著特征呢?</strong>
            <ul>
              <li>当你对联系对方有所顾虑的时候，请您尝试百度一下这个联系方式，进行多方的比对。</li>
              <li>凡是要求付路费/红包/定金/保证金/照片验证/视频验证等任何提前付费的行为，基本都是骗子。</li>
              <li>凡是裸聊、发视频验证、下载APP的，都是来骗钱或窃取个人资料的，请勿上当。</li>
              <li>凡是进入服务场所后没有提供服务就一直推荐办卡都是骗子。</li>
              <li>凡是对服务项目含糊其辞的，都是有时候猫腻的，事前一定要问清楚。</li>
              <li>凡是要求见面地方在交通方便的车站附近的，基本不靠谱。</li>
            </ul>
          </li>
          <li>
            <strong>为什么网站有一些信息过时了?</strong>
            <ul>
              <li>由于行业的特殊性，如果这条信息发布时间半年多了，过时了也正常，但请放心，本站每日大量更新全国信息，我们也建议你更多关注最新的信息。</li>
            </ul>
          </li>
          <li>
            <strong>为什么有些信息的联系方式无效？</strong>
            <ul>
              <li>由于行业的特殊性，楼凤小姐或者商家联系方式更换比较频繁，同时如果这条信息被很多狼友浏览和添加，也会导致微信或者QQ联系方式被暂时屏蔽或者直接被封。如果你无法搜索QQ和微信，这个时候请你尝试一下手机联系方式，如果长期没回复或者联系方式失效且无法添加，请关注我们同城的其它最新信息即可，我们每日更新大量全国信息，通过我们的最新信息，总会帮你找到快乐和性福。</li>
            </ul>
          </li>
          <li>
            <strong>网站的信息都是真的吗?</strong>
            <ul>
              <li>本站信息都是全国各地狼友亲自经历后发布的，再由我们网站严格审核后才通过，所以可信度请放心。我们每条信息都有一半已显示出来，特别商家频道，肯定有很多你熟悉的地方，每天那么多的信息更新，我们没有你们想象的那么强大，可以捏造出这么多虚假信息，同时如果你有顾虑，可以尝试给我们贡献内容，获取积分后，你就可以使用积分购买单个信息的联系方式，所以，本站信息是不是真的请你判断，如果你还是认为本站信息是假的，那么请你离开本站。</li>
            </ul>
          </li>
        </ol>
      </el-card>
      <el-card v-if="!loading" shadow="never" :body-style="{padding: '16px',textAlign: 'left'}" v-show="rule">
        <div class="G-title">
          <span>积分规则</span>
        </div>
        <ol style="padding-inline-start: 15px;">
          <c style="font-size: 14px">部分信息会隐藏具体地址和联系方式，需要付出积分来查看隐藏信息。帖子的积分售价根据帖子的质量由管理员来决定，同时你也可以通过升级VIP会员来享受无限制查看信息的权限。</c>
          <li>
            <strong>查看隐藏联系方式的途径：</strong>
            <ul>
              <li>通过帖子的售价付出相应的积分查看。</li>
              <li>购买月度/包年/终身会员可以无需积分查看所有隐藏信息。</li>
            </ul>
          </li>
          <li>
            <strong>获取积分途径：</strong>
            <ul>
              <li>发布真实小姐信息，经过审核后，管理员会根据您的信息内容质量在6种标准中评分，当其他人查看您的信息一次，所扣的积分也将奖励到您账户。</li>
            </ul>
          </li>
          <li>
            <strong>信息发布的奖励规则：</strong>
            <ul>
              <li>积分奖励根据帖子内容的质量由管理员来决定，分别有2种信息奖励标准【20积分 50积分】，当其他人查看您的信息一次，所扣的积分也将奖励到您账户。</li>
              <li>你可以使用积分查看信息的隐藏联系方式，当积分达到20000，您还可以使用积分升级会员。</li>
            </ul>
          </li>
        </ol>
      </el-card>
    </div>
</template>

<script>
import ad from '../widget/ad'
import {request} from '@/network/request'
export default {
  name: 'help',
  data () {
    return {
      new_url: false,
      rule: false,
      identify: false,
      new: '',
      loading: true
    }
  },
  components: {
    ad
  },
  created () {
    this.ann_new()
    this.index()
  },
  methods: {
    click_identify () {
      this.new_url = false
      this.identify = true
      this.rule = false
    },
    click_new_url () {
      this.new_url = true
      this.identify = false
      this.rule = false
    },
    click_rule () {
      this.new_url = false
      this.identify = false
      this.rule = true
    },
    index () {
      this.new_url = true
      this.identify = true
      this.rule = true
    },
    ann_new () {
      request({
        url: '/api/new',
        method: 'post'
      }).then(res => {
        this.new = res.data.new
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
  ul{
    padding-inline-start: 15px;
  }
  li {
    line-height: 1.5rem;
    font-size: 14px;
  }
  .G-title {
    border-bottom: 1px solid #f2f2f2 !important;
    padding-bottom: 10px;
    justify-content: space-between !important;
    display: flex !important;
  }
  .el-card {
    user-select: auto;
    color: #666!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/index/help.vue